import React, { useEffect, useState, useRef } from "react";
import {
  Chip,
  Button,
  Modal,
  FormFieldSet,
  CopyToClipboard,
  showToast,
  SmartTooltip,
  TableAdv,
  Backdrop,
  LogoLoader,
} from "../../../../../components";
import { mapTableRows } from "../../../../../utils";
import { useNavigate } from "react-router-dom";
import CreateTeam from "./UserTeams/CreateTeam";
import { useDispatch, useSelector } from "react-redux";
import { getUsersStart } from "../../../../../redux/slices/setting/settingsSlice";
import { usePagination } from "../../../../../hooks";
import {
  passwordUpdate,
  updateUser,
} from "../../../../../redux/slices/setting/settingApi";
import { convertFromUTC } from "../../../../../utils/dateUtils";
import { formatWords2 } from "../../../../../utils/stringUtils";
import { useLoginUser } from "../../../../../hooks/useLoginUser";




const BENCH_USER_MODULE = 4; 
const UserTeams = () => {
  const [createTeamModal, setCreateTeamModal] = useState(false);
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [resetPasswordModal, setResetPasswordModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [password, setPassword] = useState("");
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [toggleOn, setToggleOn] = useState([]);
  const [activeFilters, setActiveFilters] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [searchApplicants, setSearchApplicants] = useState([]);
  const [selectedUserName, setSelectedUserName] = useState("");  //persist user name to show in pop up
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { value } = useSelector((state) => state.totalCount);
  const { user } = useSelector((state) => state.auth);
  const { users = [] } = useSelector(
    (state) => state.settings?.accessControls?.userTeams || [],
  );
  const { loading } = useSelector((state) => state?.settings);
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );
  // console.log(value)
  // const totalCount = value?.allUsers?.data || 0;
  const totalCount = users?.[0]?.totalCount || 0; 


    const { userData: loginUserData } = useLoginUser();
    const moduleNumber = loginUserData?.role?.module;
    const isBenchUser = BENCH_USER_MODULE===moduleNumber; 

  // console.log(value)
  const userModule = user?.data?.role?.module;

  const handleToggle = (rowId) => {
    setToggleOn(
      (prev) =>
        prev.includes(rowId)
          ? prev.filter((id) => id !== rowId) // remove if exists
          : [...prev, rowId], // add if not exists
    );
  };
  const getAggregateFilter = () => {
    return {
      module: {
        type: "AG_USERS_BY_MODULE",
        value: userModule === 1 ? null : userModule,
        organizationId: user?.data?.organizationId?.uiid,
      },
    };
  };

  const whatsappIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="14"
      height="14"
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label="WhatsApp"
    >
      <title>WhatsApp</title>

      <path
        fill="#25D366"
        d="M20.52 3.48A11.94 11.94 0 0 0 12 0C5.37 0 .02 5.35.02 12c0 2.11.55 4.08 1.6 5.83L0 24l6.42-1.68A11.94 11.94 0 0 0 12 24c6.63 0 12-5.35 12-12 0-3.2-1.25-6.2-3.48-8.32z"
      />

      <path
        fill="#FFFFFF"
        d="M17.56 14.01c-.3-.15-1.76-.86-2.03-.96-.27-.1-.47-.15-.67.15-.2.3-.77.96-.95 1.15-.17.2-.34.22-.64.07-.3-.15-1.27-.47-2.42-1.48-.9-.8-1.51-1.78-1.69-2.08-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.29.3-.48.1-.2.05-.37-.03-.52-.08-.15-.67-1.6-.92-2.19-.24-.57-.48-.49-.66-.5l-.56-.01c-.2 0-.52.07-.79.37s-1.04 1.02-1.04 2.48 1.06 2.88 1.21 3.08c.15.2 2.09 3.2 5.07 4.48 2.98 1.29 2.98.86 3.52.81.54-.05 1.76-.72 2.01-1.41.25-.69.25-1.28.17-1.41-.08-.13-.27-.2-.57-.35z"
      />
    </svg>
  );

  const columns = [
    {
      key: "name",
      label: "Name",
      render: (row) => {
        if(row.userType == 2) {
          return <div className="flex items-center">
            <Button type="icon" color="danger" variant="text" icon="android" className="shrink-0" />
            <span className="text-sm line-clamp-1 truncate">{row.name}</span>
          </div>
        }
        else { return <div>{row.name}</div> }
      }
    },
    {
      key: "status",
      label: "Status",
    },
   !isBenchUser&& {
      key: "atsrole",
      label: "ATS Role",
    },
    !isBenchUser&&{
      key: "workforceRole",
      label: "Workforce Role",
    },
    {
      key: "benchsaleRole",
      label: "Benchsale Role",
    },

    // {
    //   key: "mobile",
    //   label: "Mobile",
    //   render: (row) => (
    //     <div className="flex items-center">
    //     {row?.mobile &&  <SmartTooltip description={"Phone"} noicon>
    //         <Button
    //           type="icon"
    //           variant="text"
    //           color="black"
    //           size="sm"
    //           icon={"phone_in_talk"}
    //         />
    //       </SmartTooltip>}
    //       {row?.mobile}
    //       <SmartTooltip description={"text"} noicon>
    //         <Button
    //           type="icon"
    //           variant="text"
    //           color="black"
    //           icon={"chat"}
    //           size="sm"
    //         />
    //       </SmartTooltip>
    //       <SmartTooltip description={"Whatsapp"} noicon>
    //         <Button
    //           type="icon"
    //           variant="text"
    //           color="black"
    //           icon={whatsappIcon}
    //         />
    //       </SmartTooltip>
    //     </div>
    //   ),
    // },
    {
      key: "mobile",
      label: "Mobile",
      render: (row) => {
        const mobile = row?.mobile?.trim();

        const hasMobile = mobile && mobile !== "-"

        return (
          <div className="flex items-center gap-2">
            {hasMobile ? (
              <>
                <SmartTooltip description="Phone" noicon>
                  <Button
                    type="icon"
                    variant="text"
                    color="black"
                    size="sm"
                    icon="phone_in_talk"
                  />
                </SmartTooltip>

                {mobile}

                <SmartTooltip description="Text" noicon>
                  <Button
                    type="icon"
                    variant="text"
                    color="black"
                    icon="chat"
                    size="sm"
                  />
                </SmartTooltip>

                <SmartTooltip description="Whatsapp" noicon>
                  <Button
                    type="icon"
                    variant="text"
                    color="black"
                    icon={whatsappIcon}
                  />
                </SmartTooltip>
              </>
            ) : (
              "-"
            )}
          </div>
        );
      },
    },
    {
      key: "email",
      label: "Email",
      render: (row) => (
        <div className="flex items-center">
          <CopyToClipboard content={row?.email} title={row?.email} />
          {row?.email}
        </div>
      ),
    },
    {
      key: "createdBy",
      label: "Created By",
    },
    {
      key: "createdOn",
      label: "Created On",
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex">
          <SmartTooltip description={"Edit"} noicon>
            <Button
              type="icon"
              variant="text"
              icon="edit"
              color="black"
              size="sm"
              onClick={() => {
                const safeRow = {
                  name: row?.name,
                  atsrole: row?.atsrole,
                  workforceRole: row?.workforceRole,
                  mobile: row?.mobile,
                  uiid: row?.uiid,
                };

                navigate("/settings/add-user", {
                  state: { data: safeRow, isEdit: true },
                });
              }}
            />
          </SmartTooltip>
          <SmartTooltip
            description={toggleOn.includes(row.id) ? "In Active" : "Active"}
            noicon
          >
            <Button
              type="icon"
              variant="text"
              icon={row?.rawStatus == 1 ? "toggle_on" : "toggle_off"}
              color={row?.rawStatus == 1 ? "success" : "color"}
              size="sm"
              onClick={() => {
                handleStatusToggle(row);
                handleToggle(row.id);
              }}
              // onClick={() => handleToggle(row.id)}
            />
          </SmartTooltip>
          <SmartTooltip description={"Delete"} noicon>
            <Button
              type="icon"
              variant="text"
              icon="delete"
              color="black"
              size="sm"
              onClick={() =>
               {  setSelectedUserName(row?.name);
                 setShowDeleteAlert(true)}}
            />
          </SmartTooltip>
          <SmartTooltip description={"Reset Password"} noicon>
            <Button
              type="icon"
              variant="text"
              icon="lock_reset"
              color="black"
              size="sm"
              onClick={() => {
                // console.log("ROW",row)
                setSelectedUserId(row.id);
                setResetPasswordModal(true);
              }}
            />
          </SmartTooltip>
          <SmartTooltip description={"Plugin Access"} noicon>
            <Button
              type="icon"
              variant="text"
              icon="plug_connect"
              color="black"
              size="sm"
            />
          </SmartTooltip>
        </div>
      ),
    },
  ].filter(Boolean);;
  // const rows = Array.from({ length: 10 }, (_, i) => ({
  //   name: "Ershad",
  //   status: (
  //     <Chip
  //       label={"Active"}
  //       color="success"
  //       className="text-success !py-2 !px-3"
  //     />
  //   ),
  //   atsrole: "Frontend Developer",
  //   workforceRole: "Developer",
  //   mobile: "785645655",
  //   email: "ershad@Tektree.inc",
  //   createdBy: "Pankaj Rathore",
  //   createdOn: "5 Sep 2025",
  //   actions: "",
  // }));
  const usersData = users?.[0]?.data || [];
  const rows = usersData.map((u) => {
    const mobile = u?.mobile?.primary?.number
      ? `${u?.mobile?.primary?.code} ${u?.mobile?.primary?.number}`
      : u.mobile?.secondary?.number
        ? `${u?.mobile?.secondary?.code} ${u?.mobile?.secondary?.number}`
        : "-";

    const UserStatus = {
      1: "Active",
      2: "Inactive",
    };
    const statusLabel = UserStatus[u?.status] || "Inactive";

    const status = (
      <Chip
        label={statusLabel}
        color={statusLabel === "Inactive" ? "danger" : "success"}
        className="!py-2 !px-3"
      />
    );

    const roleMap = {
      1: "ADMIN",
      2: "RA",
      3: "BDM",
      4: "RECRUITER",
      5: "EMPLOYEE",
      6: "HR",
      7: "FINANCE",
      8: "IMMIGRATION",
      30: "OTHER",
    };
    const createdOn = u?.addedOn
      ? new Date(convertFromUTC(u?.addedOn)).toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
          year: "numeric",
        })
      : "-";
    return {
      name: `${formatWords2(u?.firstName || "")} ${formatWords2(u?.lastName || "")}`,
      status: status,
      rawStatus: u?.status,
      // atsrole: roleMap[u.role] || "N/A",
      // atsrole: u.role?.[0]?.name || "N/A",
      atsrole: (u?.role?.module === 2 && u?.role?.name) || "N/A",
      // workforceRole: u.workforceRole || "N/A",
     workforceRole: (u?.role?.module === 3 && u?.role?.name) || "N/A", 
   
      benchsaleRole: (u?.role?.module === 4 && u?.role?.name) || "N/A",
      mobile: mobile,
      email: u?.email?.primary || "-",
      createdBy: formatWords2(u?.addedBy?.firstName || "-"),
      createdOn: createdOn,
      actions: "",
      id: u._id,
      uiid: u.uiid,
      userType: u.userType
    };
  });
  const mappedRows = mapTableRows(rows, columns);

  const handlePasswordSave = async () => {
    const passwordRegex =
      /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[&()#*$@])[A-Za-z\d&()#*$@]+$/;

    if (!password) {
      showToast("Password is required!", "error", 2000);
      return;
    }

    if (password.length < 8) {
      showToast("Password must be at least 8 characters!", "error", 2000);
      return;
    }

    if (!passwordRegex.test(password)) {
      showToast(
        "Password must include uppercase, lowercase, number, and one special character (& ( ) # * $ @).",
        "error",
        4000,
      );
      return;
    }

    if (!selectedUserId) {
      showToast("User ID not found!", "error", 2000);
      return;
    }

    try {
      setPasswordLoading(true);
      const res = await passwordUpdate({
        id: selectedUserId,
        password: password,
      });

      if (res?.data) {
        showToast("Password updated successfully", "success", 2000);
        setResetPasswordModal(false);
        setPassword("");
      } else {
        showToast("Failed to update password", "error", 2000);
      }
    } catch (err) {
      console.error("Password update failed:", err);
      showToast("Error while updating password", "error", 2000);
    } finally {
      // setLoading(false);
      setPasswordLoading(false);
    }
  };

  const handleStatusToggle = async (row) => {
    try {
      const currentStatus = row.rawStatus === 1 ? 1 : 2;
      const newStatus = currentStatus === 1 ? 2 : 1;

      const res = await updateUser({
        id: row.id,
        payload: {
          $set: { status: newStatus },
        },
      });

      if (res?.data) {
        showToast(
          `User status updated to ${newStatus === 1 ? "Active" : "Inactive"}`,
          "success",
          2000,
        );

        // re-fetch the list
        // dispatch(
        //   getUsersStart({
        //     coll: "User",
        //     ret: "firstName lastName role mobile email addedBy addedOn status uiid ",
        //     fil: {
        //       organizationId: {
        //         type: "NONE",
        //         value: user?.data?.organizationId?.uiid,
        //       },
        //     },
        //     lim: limit,
        //     pg: page,
        //     ref: "addedBy",
        //     sort: { addedOn: -1 },
        //   }),
        // );
        fetchAllApplicants()
      } else {
        showToast("Failed to update status", "error", 2000);
      }
    } catch (err) {
      console.error("Error updating user status:", err);
      showToast("Error while updating status", "error", 2000);
    }
  };

  const lastFilterRef = React.useRef(null);

  const handleFilterChange = React.useCallback((filterConfig) => {
    const newFilter = JSON.stringify(filterConfig);
    const oldFilter = lastFilterRef.current;

    if (newFilter === oldFilter) {
      return;
    }
    lastFilterRef.current = newFilter;
    setActiveFilters(filterConfig);
  }, []);

  useEffect(() => {
    if (searchValue.trim().length > 1) {
      handleSearch(searchValue);
    } else {
      // setTotalCount(value?.allApplicants?.data || 0);
    }
  }, [searchValue]);

  // const fetchAllApplicants = () => {
  //   console.log("fetch all applicants called");
  //   dispatch(
  //     totalCountStart({
  //       collection: "users",
  //       coll: "User",
  //       tname: "allUsers",
  //       filters: {
  //         organizationId: {
  //           type: "NONE",
  //           value: user?.data.organizationId.uiid,
  //         },
  //       },
  //       app: "master",
  //     })
  //   );
  //   dispatch(
  //     getUsersStart({
  //       coll: "User",
  //       ret: "firstName lastName role mobile email addedBy addedOn status uiid",
  //       fil: {
  //         organizationId: {
  //           type: "NONE",
  //           value: user?.data.organizationId.uiid,
  //         },
  //       },
  //       lim: limit,
  //       pg: page,
  //       ref: "addedBy Role",
  //       sort: { addedOn: -1 },
  //     })
  //   );

  // }
  const fetchAllApplicants = () => {
    dispatch(
      getUsersStart({
        coll: "User",
        useAggregate: true,
        fil: getAggregateFilter(),
        lim: limit,
        pg: page,
        sort: { addedOn: -1 },
      }),
    );
  };

  // const fetchApplicantSearch = async (data) => {
  //   console.log(data)
  //   if (
  //     data.name.length > 1 ||
  //     data.mobile.length > 1 ||
  //     data.email.length > 1
  //   ) {
  //     let params = {
  //       coll: "User",
  //       lim: limit,
  //       pg: page,
  //       extret: "uiid firstName",
  //       sort: { uiid: -1 },
  //       useAggregate: true,
  //     };

  //     if (data.searchType === "name") {
  //       // params.fil = {
  //       //   ...getAggregateFilter(),
  //       //   firstName: { type: "SEARCH", value: data.name.toLowerCase() },
  //       //   lastName: { type: "SEARCH", value: data.name.toLowerCase() },
  //       // };
  //     } else if (data.searchType === "email") {
  //       params.fil = {
  //         ...getAggregateFilter(),
  //         "email.primary.email": {
  //           type: "SEARCH",
  //           value: data.email.toLowerCase(),
  //         },
  //       };
  //     } else if (data.searchType === "mobile") {
  //       params.fil = {
  //         ...getAggregateFilter(),
  //         "mobile.primary.number": {
  //           type: "SEARCH",
  //           value: Number(data.mobile),
  //         },
  //       };
  //     }
  //     //console.log("in isde the feletc serrarch", params.fill);

  //     dispatch(getUsersStart(params));
  //     //console.log("hereee filer", params.fil);
  //     console.log(params.fil)
  //     // dispatch(
  //     //   totalCountStart({
  //     //     collection: "users",
  //     //     coll: "User",
  //     //     tname: "allUsers",
  //     //     app: "master",
  //     //     filters: params.fil,
  //     //   })
  //     // );
  //   }
  // };

  const fetchApplicantSearch = async (data) => {
    if (
      data.name.length > 1 ||
      data.mobile.length > 1 ||
      data.email.length > 1
    ) {
      let params = {
        coll: "User",
        lim: limit,
        pg: page,
        sort: { addedOn: -1 },
        useAggregate: true,
      };

      if (data.searchType === "name") {
        params.fil = {
          ...getAggregateFilter(),
          search: {
            type: "SEARCH",
            value: {
              searchType: "name",
              name: data.name.toLowerCase(),
            },
          },
        };
      } else if (data.searchType === "email") {
        params.fil = {
          ...getAggregateFilter(),
          search: {
            type: "SEARCH",
            value: {
              searchType: "email",
              email: data.email.toLowerCase(),
            },
          },
        };
      } else if (data.searchType === "mobile") {
        params.fil = {
          ...getAggregateFilter(),
          search: {
            type: "SEARCH",
            value: {
              searchType: "mobile",
              mobile: data.mobile,
              countryCode: data.countryCode,
            },
          },
        };
      }

      dispatch(getUsersStart(params));
    }
  };

  useEffect(() => {
    if (searchValue.trim().length > 1) {
      handleSearch(searchValue);
    } else if (
      activeFilters?.allFilterConditions?.length > 0 ||
      activeFilters?.anyFilterConditions?.length > 0
    ) {
      const fil = buildFilParams(activeFilters);
      getFilterData(fil);
    } else {
      fetchAllApplicants();
      // setTotalCount(value?.allApplicants?.data || 0);
    }
  }, [dispatch, limit, page, searchValue]);

  const searchTimer = useRef(null);

  const handleSearch = (value) => {
    if (page !== 1) {
      setPage(1);
    }
    let searchType = "";
    let email = "";
    let name = "";
    let mobile = "";
    let countryCode = "";

    const trimmed = (value || "").trim();

    if (trimmed.includes("@")) {
      searchType = "email";
      email = trimmed;
    } else {
      const cleaned = trimmed.replace(/[\s\-().]/g, "");
      const numericRegex = /^\+?\d+$/;
      if (!numericRegex.test(cleaned)) {
        searchType = "name";
        name = trimmed;
      } else {
        const validCC = ["91", "1"];
        if (cleaned.startsWith("+")) {
          const digits = cleaned.slice(1);
          let matched = false;
          for (const cc of validCC) {
            if (digits.startsWith(cc)) {
              matched = true;
              countryCode = "+" + cc;
              mobile = digits.slice(cc.length);
              break;
            }
          }
          if (!matched) {
            mobile = digits;
          }
          searchType = "mobile";
        } else {
          let matched = false;
          for (const cc of validCC) {
            if (cleaned.startsWith(cc)) {
              matched = true;
              countryCode = "+" + cc;
              mobile = cleaned.slice(cc.length);
              break;
            }
          }
          if (!matched) {
            mobile = cleaned;
          }
          searchType = "mobile";
        }
      }
    }

    if (searchTimer.current) clearTimeout(searchTimer.current);

    searchTimer.current = setTimeout(() => {
      fetchApplicantSearch({
        searchType,
        email,
        name,
        mobile,
        countryCode,
      });
    }, 500);
  };

  return (
    <>
      <div className="flex flex-col gap-5 my-5 flex-1 overflow-hidden">
        <div className="flex-1 overflow-auto flex gap-4 p-0.5">
          <TableAdv
            rows={mappedRows}
            columns={columns}
            serverPagination={true}
            totalCount={totalCount}
            page={page}
            limit={limit}
            onPaginationChange={setPage}
            onLimitChange={handleLimitChange}
            onFilterChange={handleFilterChange}
            // tdClassName="!py-3"
            serverOnSearch={(key, value) => {
              setSearchValue(value);
            }}
            toolbarRight={{
              search: true,
              filter: false,
              download: false,
              add: [
                {
                  component: (
                    <div className="flex items-center gap-1">
                    {!isBenchUser &&  <Button
                        title="Create Team"
                        size="sm"
                        variant="outlined"
                        onClick={() => setCreateTeamModal(true)}
                      />
                    }
                      <Button
                        title="Add user"
                        icon="add"
                        size="sm"
                        onClick={() => navigate("/settings/add-user")}
                      />
                    </div>
                  ),
                },
              ],
            }}
          />
        </div>
      </div>

      {createTeamModal && (
        <Modal
          isOpen={createTeamModal}
          title={"Create Team"}
          onClose={() => setCreateTeamModal(false)}
          width="max-w-4xl"
          titleColor={"primary"}
        >
          <CreateTeam onCancel={() => setCreateTeamModal(false)} />
        </Modal>
      )}

      <Modal
        showCloseButton={false}
        isOpen={showDeleteAlert}
        onClose={() => {
          setShowDeleteAlert(false);
        }}
      >
        <div className="text-center my-3">
          <p>Are you sure you want to delete</p>
          <p className="text-info">{selectedUserName}</p>
          <p>from my User Teams?</p>
          <div className="flex justify-center items-center gap-3 mt-8">
            <Button
              title="Cancel"
              variant="outlined"
              color="black"
              onClick={() => {
                setShowDeleteAlert(false);
              }}
            />
            <Button
              title="Delete"
              onClick={() => {
                setShowDeleteAlert(false);
              }}
            />
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={resetPasswordModal}
        title={"Reset Password"}
        onClose={() => {
          setPassword("");
          setResetPasswordModal(false);
        }}
        titleColor={"primary"}
        // width="max-w-4xl"
      >
        <div className="p-4">
          <div className="me-20">
            <FormFieldSet
              type="password"
              noTitle
              placeholder="Enter Password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
          </div>

          <div className="flex justify-end items-center gap-2 mt-10">
            <Button
              title="Cancel"
              variant="outlined"
              color="black"
              onClick={() => {
                setPassword("");
                setResetPasswordModal(false);
              }}
            />
            <Button title="Save" onClick={handlePasswordSave} />
          </div>
        </div>
      </Modal>
      <Backdrop isOpen={loading || passwordLoading}>
        <LogoLoader />
      </Backdrop>
    </>
  );
};

export default UserTeams;
